import Notification from 'interfaces/Notification';
import '../stylesheets/NotificationDetails.scss';

type DefaultTemplateProps = {
    notification: Notification;
    onClick?: (...args) => void;
};

const DefaultTemplate = ({ notification, onClick }: DefaultTemplateProps) => {
    return (
        <div id="notification-details-content">
            <p>{notification.content}</p>
            {onClick && (
                <button id="notification-details-action" onClick={onClick}>
                    Address Issue
                </button>
            )}
        </div>
    );
};
export default DefaultTemplate;
